<div *ngIf="profileService.profile$ | async as profile; else loading" class="card">
    <div class="card-header profile-header">
        <div class="container">
            <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6 text-center">
                    <div class="profile-image-container">
                        <div class="profile-ring" [style.--percent]="profile.profile.percentComplete * 100">
                            <!--  If for any reason the API fetch for the profile photo fails we want to disable the ability to edit.  -->
                            <div *ngIf="!isPhotoApiFailed" class="image-edit-container" data-bs-toggle="modal" data-bs-target="#editPhotoModal">
                                <i class="fas fa-camera image-edit"></i>
                            </div>

                            <img #profileImg
                                 class="profile-image"
                                 src="{{profile.biodata.photoUrl}}"
                                 alt="{{profile.biodata.displayName}}"
                                 (error)="profileImg.src = profile.biodata.failedPhotoUrl; isPhotoApiFailed = true">
                        </div>

                            <div class="text-muted mt-1">
                                <small><strong>Profile - {{profile.profile.percentComplete | percent}}</strong></small><br />
                                <button class="btn btn-sm btn-primary"
                                        data-bs-toggle="modal"
                                        data-bs-target="#editPhotoModal"
                                        [disabled]="isPhotoApiFailed">
                                    Edit photo
                                </button>
                            </div>
                        </div>
                        <div *ngIf="isPhotoApiFailed" class="alert alert-warning p-1 my-2">We are experiencing issues displaying photos.  Photo edits cannot be made at this time.</div>

                    </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                    <div class="col-sm-12 col-md-12 col-lg-12 text-center ">
                        <h4 class="card-title">{{profile.biodata.displayName}}</h4>

                        <h5 class="card-subtitle">
                            <ng-container *ngIf="profile.employeeData.FacultyTitle">
                                {{profile.employeeData.FacultyTitle}}
                            </ng-container>

                            <ng-container *ngIf="!profile.employeeData.FacultyTitle">
                                {{profile.biodata.description}}{{(profile.biodata.isAdvancedStanding) ? ' - Advanced Standing' : ''}}
                            </ng-container>

                        </h5>
                        <ng-container *ngFor="let val of profile.biodata.diplomaCertificates; let last = last">
                            <div class="d-flex justify-content-center align-items-center">
                                <div class="border border-1 border-dark rounded bg-light justify-content-between px-2 mt-1 me-1 text-break"
                                     [style.width]="150+'px'">
                                    <div class="small">{{val}}</div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="profile.employeeData.AcademicArea">
                            <p><small class="text-muted">{{profile.employeeData.AcademicArea}}</small></p>
                        </ng-container>

                        <ng-container *ngIf="profile.employeeData.Division && (profile.employeeData.AcademicArea != profile.employeeData.Division)">
                            <p><small class="text-muted">{{profile.employeeData.Division}}</small></p>
                        </ng-container>
                    </div>
                    <div *ngIf=" (profileService.viewConcentrations$ | async ) as concData; else loading">
                        <ng-container *ngIf="concData.concentrations.length > 0">
                            <hr>
                            <ng-container *ngIf="!profileService.isUpdating.includes('conc'); else loading">
                                <div *ngFor="let concentration of concData.concentrations;"><small class="text-muted">{{concentration.Name}}: {{concentration.Value}}</small></div>
                                <button *ngIf="!!concData.userMayEditConcentration" class="btn btn-sm btn-block btn-primary" (click)="openConc(concData.concentrations)">Update {{concData.concentrations[0].Type}}<span *ngIf="concData.concentrations.length > 1">s</span></button>
                            </ng-container>
                        </ng-container>
                    </div>
                    <div *ngIf="auth.isSpoofingAudience" class="text-center">
                        <p>Spoofing Audience: {{auth.token.payload.AudienceUi}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body profile-body">
        <div *ngIf="profile.biodata.ferpaNuclear" class="alert alert-danger">
            You have elected to have all of your directory information made private. This means that other students will not see you listed in class rosters, my classmates, or any other list of students. For more information visit the <a target="_blank" href="https://registrar.unc.edu/academic-services/uncferpa/">UNC Registrar</a>.
        </div>

        <!-- TAB NAVIGATION-->
        <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item"><a class="nav-link" href="#contact" data-bs-toggle="tab" role="tab" aria-controls="contact" aria-selected="false">Contact Info</a></li>
            <li class="nav-item"><a class="nav-link active show" href="#profile" data-bs-toggle="tab" role="tab" aria-controls="profile" aria-selected="true">Profile</a></li>
            <li *ngIf="(auth.hasClaim('Kfbs.Context.SpoofAs') || auth.hasClaim('Kfbs.Environment.ChangeAudience'))" class="nav-item"><a class="nav-link" href="#spoofing" data-bs-toggle="tab" role="tab" aria-controls="spoofing" aria-selected="false">Spoofing</a></li>
            <li class="nav-item"><a class="nav-link" *ngIf="profile.version != 2" href="#settings" data-bs-toggle="tab" role="tab" aria-controls="settings" aria-selected="false">Settings</a></li>            
            <!--<li class="nav-item"><a class="nav-link" *ngIf="canViewThemes() && (profile.version != 2)" href="#themes" data-bs-toggle="tab" role="tab" aria-controls="themes" aria-selected="false">Themes</a></li>-->
        </ul>

        <div class="tab-content">
            <!-- CONTACT INFO TAB -->
            <div class="tab-pane fade" id="contact" role="tabpanel">
                <ng-container *ngIf="profileService.contactInfo$ | async as contact; else loading">
                    <div class="row row-cols-1 row-cols-md-2 g-4">
                        <ng-container *ngIf="auth.hasFeature('ContactInfo')">
                            <div class="col">
                                <section class="card">
                                    <header class="card-header">Phones</header>
                                    <div class="card-body">
                                        <div *ngIf="contact.phones.length == 0">No phone numbers found</div>
                                        <div *ngFor="let phone of contact.phones; let i = index" class="alert">
                                            <i *ngIf="phone.isPrivate" class="fas fa-lock" title="FERPA Privacy Requested"></i>
                                            {{phone.location}}<br />
                                            {{phone.number}}
                                        </div>
                                    </div>
                                    <div class="card-footer"><small>Update phone numbers in <a href="https://connectcarolina.unc.edu" target="_blank">ConnectCarolina</a></small></div>
                                </section>
                            </div>
                            <div class="col">
                                <section class="card">
                                    <header class="card-header">Addresses</header>
                                    <div class="card-body">
                                        <div *ngIf="contact.addresses.length == 0">No addresses found</div>
                                        <div *ngFor="let address of contact.addresses" class="alert">
                                            <i *ngIf="address.isPrivate" class="fas fa-lock" title="FERPA Privacy Requested"></i>
                                            {{address.type}}<br />
                                            <div *ngFor="let line of address.lines">
                                                {{line}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-footer"><small>Update addresses in <a href="https://connectcarolina.unc.edu" target="_blank">ConnectCarolina</a></small></div>
                                </section>
                            </div>
                        </ng-container>
                        <div class="col">
                            <section class="card" *ngIf="auth.hasFeature('OfficeInfo')">
                                <header class="card-header">Office</header>
                                <div class="card-body">
                                    <div><strong>Location: </strong> {{profile.employeeData.Office}}</div>
                                    <div><strong>Phone: </strong> {{profile.employeeData.Phone}}</div>
                                </div>
                                <div class="card-footer"><small>Office information maintained by <a href="mailto:facilities@kenan-flagler.unc.edu">Facilities</a></small></div>
                            </section>
                        </div>
                    </div>
                </ng-container>
            </div>

            <!-- PROFILE TAB -->
            <div class="tab-pane fade active show" id="profile" role="tabpanel">
                <ng-container *ngIf="auth.hasFeature('PublishProfile')">
                    <p class="alert alert-danger" *ngIf="!profile.profile.isProfilePublished">
                        <strong>
                            {{profile.profile.unPublishedCount}} <span *ngIf="profile.profile.unPublishedCount > 1">entries</span>
                            <span *ngIf="profile.profile.unPublishedCount == 1">entry</span> in your profile
                            <span *ngIf="profile.profile.unPublishedCount > 1">are</span>
                            <span *ngIf="profile.profile.unPublishedCount == 1">is</span>
                            not yet published
                        </strong> (<i class="fad fa-lock-alt"></i>).
                        Your classmates will only be able to see entries you have published. Unpublished entries may prevent them finding you when searching their network.
                        Faculty and administrative users may still have rights to see your unpublished entries.
                        Update your profile below, then click Save &amp; Publish All to make all entries visible.
                    </p>
                    <p class="alert alert-info" *ngIf="profile.profile.isProfilePublished">
                        Your profile is <strong>published</strong> and {{profile.profile.percentComplete | percent}} complete.
                        Your fellow students will be able to see your profile and have a better chance of finding you when searching their networks. Update your profile below, then click Save &amp; Publish All below.
                    </p>
                </ng-container>
                <form name="profileForm" (ngSubmit)="onProfileSubmit( profile.profile.required ); form.form.markAsPristine();" #form="ngForm">

                    <!-- REQUIRED FIELDS -->
                    <div *ngFor="let setting of profile.profile.required" class="row mb-3">

                        <label class="col-lg-2 col-form-label" for="{{setting.Type}}_{{setting.Id}}">
                            {{setting.DisplayName}}
                            &nbsp;<i *ngIf="!setting.IsPublished && auth.hasFeature('PublishProfile')" class="fad fa-lock-alt"></i>
                        </label>
                        <div class="col-lg-10">
                            <!--  Valid Types = { "longtext", "text", "number", "bool", "datetime", "date", "time", "single", "multi", "combo-limit", "datalist" }; -->
                            <div [ngSwitch]="setting.Type">
                                <div *ngIf="!setting.Editable">
                                    {{setting.Value}}
                                </div>
                                <div *ngIf="setting.Editable">
                                    <textarea [(ngModel)]="setting.Value" *ngSwitchCase="'longtext'" id="{{setting.Type}}_{{setting.Id}}" name="{{setting.Type}}_{{setting.Id}}" class="form-control" placeholder="{{setting.Placeholder}}"></textarea>
                                    <input [(ngModel)]="setting.Value" *ngSwitchCase="'text'" id="{{setting.Type}}_{{setting.Id}}" name="{{setting.Type}}_{{setting.Id}}" class="form-control" type="text" [maxLength]="setting.TextLength" placeholder="{{setting.Placeholder}}">
                                    <input [(ngModel)]="setting.Value" *ngSwitchCase="'number'" id="{{setting.Type}}_{{setting.Id}}" name="{{setting.Type}}_{{setting.Id}}" class="form-control" type="number" placeholder="{{setting.Placeholder}}">
                                    <input [(ngModel)]="setting.Value" *ngSwitchCase="'datetime'" id="{{setting.Type}}_{{setting.Id}}" name="{{setting.Type}}_{{setting.Id}}" class="form-control" type="datetime-local" placeholder="{{setting.Placeholder}}">
                                    <input [(ngModel)]="setting.Value" *ngSwitchCase="'date'" id="{{setting.Type}}_{{setting.Id}}" name="{{setting.Type}}_{{setting.Id}}" class="form-control" type="date" placeholder="{{setting.Placeholder}}">
                                    <input [(ngModel)]="setting.Value" *ngSwitchCase="'time'" id="{{setting.Type}}_{{setting.Id}}" name="{{setting.Type}}_{{setting.Id}}" class="form-control" type="time" placeholder="{{setting.Placeholder}}">
                                    <input [(ngModel)]="setting.Value" *ngSwitchCase="'bool'" id="{{setting.Type}}_{{setting.Id}}" name="{{setting.Type}}_{{setting.Id}}" class="form-check-input" type="checkbox">
                                    <select [(ngModel)]="setting.Value" *ngSwitchCase="'single'" class="form-select" id="{{setting.Type}}_{{setting.Id}}" name="{{setting.Type}}_{{setting.Id}}">
                                        <option *ngFor="let option of setting.Options" [ngValue]="option">{{option}}</option>
                                    </select>
                                    <select [(ngModel)]="setting.Value" *ngSwitchCase="'multi'" multiple class="form-select" id="{{setting.Type}}_{{setting.Id}}" name="{{setting.Type}}_{{setting.Id}}">
                                        <option *ngFor="let option of setting.Options" [value]="option">{{option}}</option>
                                    </select>
                                    <ng-container *ngSwitchCase="'datalist'">
                                        <input [(ngModel)]="setting.Value" [attr.list]="setting.Type + '_' + setting.Id + '_options'"
                                               class="form-control" id="{{setting.Type}}_{{setting.Id}}" name="{{setting.Type}}_{{setting.Id}}" placeholder="Select or type your choice" autocomplete="off" />
                                        <datalist id="{{setting.Type}}_{{setting.Id}}_options">
                                            <option *ngFor="let option of setting.Options" [value]="option"></option>
                                        </datalist>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- SAVE PROFILE -->
                    <button class="btn btn-primary" type="submit" [disabled]="!form.valid || !form.dirty">
                        Save <span *ngIf="auth.hasFeature('PublishProfile')"> &amp; Publish All</span>
                    </button>
                    <span style="padding-left:15px">
                        <span *ngIf="form.pristine && !this.isSaved">No changes yet to save. </span>
                        <span *ngIf="form.pristine && this.isSaved">All entries have been saved. </span>
                        <span *ngIf="!form.valid" class="bg-danger">Please correct the answers indicated above. </span>
                        <span *ngIf="auth.hasFeature('PublishProfile')">You can also <span class="btn-link" style="cursor:pointer" (click)="onProfileSubmit( profile.profile.required, true ); form.form.markAsPristine();">Save &amp; Unpublish All</span>. </span>
                    </span>
                </form>
            </div>

            <!-- SPOOFING TAB -->
            <div class="tab-pane fade show" id="spoofing" role="tabpanel">
                <br />
                <form>

                    <!-- SPOOFING AS-->
                    <div *ngIf="auth.hasClaim('Kfbs.Context.SpoofAs')" class="row form-group">
                        <div class="col-sm-9 spoofing-input">
                            <person-type-ahead [(container)]="peopleService"
                                               field="typeaheadQuery"
                                               [labelText]="'Select A Person'"
                                               [placeholder]="'Search by username, last name or PID'"
                                               [helpText]="'Select a person to spoof by username, last name or PID.  If you cannot find the person you want their record may no longer be active.'"
                                               [labelCols]="3"
                                               [searchResults$]="searchResults$"
                                               [noFocusHide]="true"
                                               (returnSearchString)="triggerSearch($event)"
                                               (returnSelectedPerson)="selectPerson($event)"
                                               class="person-type-ahead">
                            </person-type-ahead>
                        </div>
                        <div class="col-sm-3">
                            <button class="btn btn-primary" type="button" (click)="isSpoofRunning = true; auth.spoof(selectedPerson.Pid);" [disabled]="!selectedPerson || !selectedPerson.Pid || (isSpoofRunning && !auth.spoofResponse)">
                                <span *ngIf="isSpoofRunning && !auth.spoofResponse" class="loader loader-sm loader-light" role="status" aria-hidden="true"></span>
                                Spoof
                            </button>
                        </div>
                        <div *ngIf="auth.spoofResponse" class="alert alert-danger col-sm-12">
                            <strong>Error: </strong> Spoof returned with the status "{{auth.spoofResponse.statusText}}."  This means that the PID you are searching for
                            <span *ngIf="auth.spoofResponse.status == '401'"> does not have access to MyKE.</span>
                            <span *ngIf="auth.spoofResponse.status == '500'"> doesn't seem to exist.</span>
                            <span *ngIf="auth.spoofResponse.status != '500' && auth.spoofResponse.status != '401'"> experienced an unknown issue.</span>
                        </div>

                    </div>

                    <!-- CHANGE AUDIENCE -->
                    <div *ngIf="auth.hasClaim('Kfbs.Environment.ChangeAudience')" class="row form-group mt-2">
                        <div class="col-sm-9 row mx-0">
                            <label class="col-sm-3 col-form-label px-0" for="audiences">Audiences</label>
                            <div class="col-sm-9 px-0">
                                <select #changeAudience class="form-select" id="audiences">
                                    <option value="|EMBA-E|">EMBA-E</option>
                                    <option value="|EMBA-EC|">EMBA-EC</option>
                                    <option value="|EMBA-W|">EMBA-W</option>
                                    <option value="|Faculty|">Faculty</option>
                                    <option value="|MAC|">MAC</option>
                                    <option value="|MAC Online|">MAC Online</option>
                                    <option value="|Incoming|">MBA, Incoming</option>
                                    <option value="|Exchange|">MBA, Exchange</option>
                                    <option value="|First Year|">MBA, First Year</option>
                                    <option value="|Second Year|">MBA, Second Year</option>
                                    <option value="|MBA@UNC|">MBA&#64;UNC</option>
                                    <option value="|MSM|">MSM</option>
                                    <option value="|PhD|">PhD</option>
                                    <option value="|Staff|">Staff</option>
                                    <option value="|UBP|">UBP</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <button class="btn btn-primary" type="button" (click)="isAudienceRunning = true; auth.reaudience(changeAudience.value)" [disabled]="isAudienceRunning || isRevertAudienceRunning">
                                <span *ngIf="isAudienceRunning" class="loader loader-sm loader-light" role="status" aria-hidden="true"></span>
                                Join
                            </button>
                            <button *ngIf="auth.isSpoofingAudience || isRevertAudienceRunning" class="btn btn-primary ml-1" type="button" (click)="isRevertAudienceRunning = true; auth.reaudience(auth.token.payload.AudiencesOrig)" [disabled]="isRevertAudienceRunning">
                                <span *ngIf="isRevertAudienceRunning" class="loader loader-sm loader-light" role="status" aria-hidden="true"></span>
                                Revert
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <!-- THEMES TAB -->
            <!--<div class="tab-pane fade show" id="themes" *ngIf="canViewThemes() && (profile.version != 2)" role="tabpanel">
                <br/>
                <section class="card card-fluid">
                    <header class="card-header drag-handle">Select your theme</header>
                    <div class="row">
                        <div *ngFor="let theme of profileService.availablethemes" class="col-3 theme-img">
                            <img (click)="selectTheme('theme-' + theme.Name)" class="img-fluid" src="assets/images/themes/myke-themes-{{theme.Name}}.png" alt="{{theme.Name}}"/><br />
                            <div class="theme-title">{{theme.Display}}</div>
                        </div>
                    </div>
                </section>
            </div>-->
            <div *ngIf="profile.version != 2" class="tab-pane fade show" id="settings" role="tabpanel">
                <section id="switcher" class="card card-fluid">
                    <header class="card-header drag-handle">Dashboard Widgets</header>
                    <div class="list-group list-group-flush list-group-bordered">
                        <div *ngFor="let widget of profileService.widgetLabelLookup | sortSettings" class="list-group-item d-flex justify-content-between align-items-center">
                            <span>{{widget.value}}</span>
                            <label class="switcher-control switcher-control-lg">
                                <input type="checkbox" class="switcher-input" [checked]="profileService.widgetStore[widget.key]['IsFave']" (click)="toggleFavorite(profileService.widgetStore[widget.key])">
                                <span class="switcher-indicator"></span>
                                <span class="switcher-label-on">ON</span>
                                <span class="switcher-label-off">OFF</span>
                            </label>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <!--{{profile | json}}-->
</div>

<!-- EDIT PHOTO MODAL -->
<div class="modal fade has-shown" id="editPhotoModal" tabindex="-1" role="dialog" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Update your public profile photo</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                </button>
            </div>
            <div class="modal-body">
                <p>
                    Your uploaded photo becomes your personalized profile photo for several systems, including MyKE and Canvas. Choose a new profile photo and crop it to show your face.
                    You can also <span class="btn-link" data-bs-dismiss="modal" (click)="deleteCustomProfilePhoto()">remove</span> your custom profile photo, and it will be replaced by the photo we have on file for you (if any).
                </p>
                <label for="photoInput" class="sr-only">Upload your photo</label>
                <input type="file" id="photoInput" accept=".jpg,.jpeg,image/jpeg" (change)="fileChangeEvent($event)" />
                <div *ngIf="uploadError" class="alert alert-danger mt-2 p-2 mb-0" role="alert">{{uploadError}}</div>
                <image-cropper [imageChangedEvent]="imageChangedEvent$ | async"
                               [maintainAspectRatio]="true"
                               [aspectRatio]="1 / 1"
                               [resizeToWidth]="128"
                               [roundCropper]="true"
                               format="png"
                               output="base64"
                               (imageCropped)="imageCropped($event)"
                               (imageLoaded)="imageLoaded()"
                               style="max-height: 33vh"
                               (loadImageFailed)="loadImageFailed()"></image-cropper>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="saveCustomProfilePhoto()">Save</button>
            </div>
        </div>
    </div>
</div>

<ng-template #loading>
    <div class="widget-action-loading text-center">
        <div class="typing">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
        </div>
    </div>
</ng-template>

<ng-template #computers let-equipment='equipment'>
    <strong>Computer</strong>
    <ul>
        <ng-container *ngFor="let computer of equipment">
            <li>
                {{computer.Model}} ({{computer.Site}})
                <button type="button" class="btn btn-link btn-sm" (click)="isExpanded[computer.Id] = !isExpanded[computer.Id]">
                    {{isExpanded[computer.Id] ? 'Collapse' : 'Expand'}}
                </button>

                <ul *ngIf="isExpanded[computer.Id]">
                    <li *ngIf="!computer.DepartmentalAsset"><strong>Position Number: </strong>{{computer.PositionNumber}}</li>
                    <li><strong>Department: </strong>{{computer.Department}}</li>
                    <li><strong>Name: </strong>{{computer.Name}}</li>
                    <li><strong>Type: </strong>{{computer.Type}}</li>
                    <li><strong>Serial #: </strong>{{computer.Serial}}</li>
                    <li><strong>Manufacturer: </strong>{{computer.Manufacturer}}</li>
                    <li><strong>Asset Tag: </strong>{{computer.AssetTag}}</li>
                    <li><strong>Last Inventoried: </strong>{{computer.LastInventoried}}</li>
                </ul>
            </li>
        </ng-container>
    </ul>
</ng-template>

<ng-template #assets let-equipment='equipment'>
    <ng-container *ngFor="let group of equipment | keyvalue">
        <strong>{{group.key}}</strong>
        <ul>
            <ng-container *ngFor="let asset of group.value">
                <li>
                    {{asset.Model}} ({{asset.Site}})
                    <button type="button" class="btn btn-link btn-sm" (click)="isExpanded[asset.Id] = !isExpanded[asset.Id]">
                        {{isExpanded[asset.Id] ? 'Collapse' : 'Expand'}}
                    </button>

                    <ul *ngIf="isExpanded[asset.Id]">
                        <li *ngIf="!asset.DepartmentalAsset"><strong>Position Number: </strong>{{asset.PositionNumber}}</li>
                        <li><strong>Department: </strong>{{asset.Department}}</li>
                        <li><strong>Name: </strong>{{asset.Name}}</li>
                        <li><strong>Serial #: </strong>{{asset.Serial}}</li>
                        <li><strong>Manufacturer: </strong>{{asset.Manufacturer}}</li>
                        <li><strong>Asset Tag: </strong>{{asset.AssetTag}}</li>
                        <li><strong>Last Inventoried: </strong>{{asset.LastInventoried}}</li>
                    </ul>
                </li>

            </ng-container>
        </ul>

    </ng-container>
</ng-template>
